import React from 'react';
import { InlineEditor } from 'components';

function DateEditor({ ...props }) {
  return <InlineEditor.Date {...props} />;
}

export default DateEditor;
